import { useMemo } from "react";

interface RuntimeConfig {
  REACT_APP_LIFT_NET_LOCAL_API_OFFLINE: string;
  REACT_APP_WEB_SOCKET_OFFLINE: string;
}

/**
 * Reads the two offline endpoints from the runtime configuration.
 *
 * Since public/config.js is loaded synchronously ahead of the bundle, and
 * config-overrides.js compiles every key in runtime-config-keys.js into the
 * same lookup, `process.env.REACT_APP_*` now resolves through
 * window.RUNTIME_CONFIG on its own. This hook is therefore no longer the only
 * way to reach runtime config -- but it stays, because it is the documented
 * accessor and its callers do not need to care how the value arrives.
 *
 * An absent key and an empty string are both "not configured for this
 * deployment" and both fall through to the build-time value, which is what
 * keeps an uncustomised deployment behaving exactly as it did before.
 */
export default function useRuntimeConfig(): RuntimeConfig {
  return useMemo(() => {
    const cfg = window.RUNTIME_CONFIG;
    if (!cfg) {
      // eslint-disable-next-line no-console
      console.warn("⚠️ RUNTIME_CONFIG not found; falling back to build-time values.");
    }
    return {
      REACT_APP_LIFT_NET_LOCAL_API_OFFLINE:
        cfg?.REACT_APP_LIFT_NET_LOCAL_API_OFFLINE ||
        process.env.REACT_APP_LIFT_NET_LOCAL_API_OFFLINE ||
        "",
      REACT_APP_WEB_SOCKET_OFFLINE:
        cfg?.REACT_APP_WEB_SOCKET_OFFLINE || process.env.REACT_APP_WEB_SOCKET_OFFLINE || "",
    };
  }, []);
}
